import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-grow text-primary",
  role: "status"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "table table-bordered table-striped table-hover"
}
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "table-group-divider" }
const _hoisted_8 = { class: "p-3 td-right" }
const _hoisted_9 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BotaoAcoes = _resolveComponent("BotaoAcoes")!
  const _component_BotaoComponent = _resolveComponent("BotaoComponent")!
  const _component_BotaoEditar = _resolveComponent("BotaoEditar")!
  const _component_BotaoExcluir = _resolveComponent("BotaoExcluir")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("v-if", true),
    (!_ctx.loading && _ctx.listas.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _createElementVNode("thead", _hoisted_6, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabecalhoTabela, (header) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.topico,
                  scope: "col",
                  class: "min-w-150px p-3 px-5"
                }, _toDisplayString(header.topico), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listas, (lista) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: lista.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dadosTabela, (dado) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: dado.campo,
                    class: "p-3 px-5 td-middle"
                  }, [
                    _renderSlot(_ctx.$slots, "default", {
                      listaSlot: lista,
                      colunaSlot: dado.campo
                    }, () => [
                      _createTextVNode(_toDisplayString(lista[dado.campo]), 1 /* TEXT */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _withDirectives(_createElementVNode("td", _hoisted_8, [
                  (_ctx.acoes.length && !_ctx.apenasVisualizar)
                    ? (_openBlock(), _createBlock(_component_BotaoAcoes, {
                        key: 0,
                        acoes: _ctx.acoes,
                        id: lista.id,
                        onActionClick: _ctx.handleActionClick
                      }, null, 8 /* PROPS */, ["acoes", "id", "onActionClick"]))
                    : (_ctx.apenasVisualizar)
                      ? (_openBlock(), _createBlock(_component_BotaoComponent, {
                          key: 1,
                          text: "Visualizar",
                          onClick: ($event: any) => (_ctx.goToRoute(lista.id))
                        }, null, 8 /* PROPS */, ["onClick"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_ctx.rotaEdit)
                            ? (_openBlock(), _createBlock(_component_BotaoEditar, {
                                key: 0,
                                rotaEdit: _ctx.rotaEdit,
                                rotaId: lista.id,
                                iconClass: _ctx.iconClass,
                                classe: 'btn btn-sm btn-primary d-inline-flex align-items-center gap-1 flex-nowrap text-nowrap',
                                btnText: _ctx.btnText
                              }, null, 8 /* PROPS */, ["rotaEdit", "rotaId", "iconClass", "btnText"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.deleteAction)
                            ? (_openBlock(), _createBlock(_component_BotaoExcluir, {
                                key: 1,
                                class: _normalizeClass(_ctx.rotaEdit ? 'ms-2' : ''),
                                btnText: 'Excluir',
                                onClick: () => _ctx.deleteAction?.(lista.id)
                              }, null, 8 /* PROPS */, ["class", "onClick"]))
                            : _createCommentVNode("v-if", true)
                        ]))
                ], 512 /* NEED_PATCH */), [
                  [_vShow, !_ctx.hideAction]
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.mensagemNenhumRegistro), 1 /* TEXT */)
        ]))
  ]))
}